import React, { useRef } from 'react';
import SideBar from './SideBar';
import Main from './Main';
import './App.css';
import FloatingSideBar from './FloatingSideBar';
function Home(){

    const aboutRef = useRef(null);
    const educationRef = useRef(null);
    const skillsRef = useRef(null);
    const blogRef = useRef(null);
    const contactRef = useRef(null);
  
    const refs = {
      aboutRef,
      educationRef,
      skillsRef,
      blogRef,
      contactRef
    };

    const isMobileDevice = () => {
      return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(navigator.userAgent);
  };

    return (
        <>
        <div className='Ellipse1'></div>
        <div className='Ellipse2'></div>
        <div className='content'>
          {
            isMobileDevice() ?  <div className='floatingIcon'>< FloatingSideBar refs={refs} /></div> :
          <div className='sliderComp'>
          <SideBar refs={refs} />
        </div>
          }
          <div className='mainComp'>
            <Main refs={refs} />
          </div>
        </div>
        </>
    )
}

export default Home